import { render } from "./FooterCom.vue?vue&type=template&id=426bb7ba&scoped=true"
import script from "./FooterCom.vue?vue&type=script&lang=js"
export * from "./FooterCom.vue?vue&type=script&lang=js"

import "./FooterCom.vue?vue&type=style&index=0&id=426bb7ba&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-426bb7ba"]])

export default __exports__